<template>
    <div class="option">
        <lazy-image
            v-if="image.src"
            class="option-image"
            :src="image.src || ''"
            :alt="image.alt || `${text} ${ $snippet('icon_alt_suffix', 'icon') }`"
            :width="image.width"
            :height="image.height"
            v-test:optionIconImage
        />

        <div class="text">
            <span
                class="option-text"
                v-html="apostrophise(text)"
                v-test:optionIconText
            />

            <span
                v-if="subtext"
                class="option-subtext"
                v-test:optionIconSubtext
            >
                {{ subtext }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'option-icon',

        props: {
            text: {
                type: String,
                default: '',
            },

            subtext: {
                type: String,
                default: '',
            },

            image: {
                type: Object,
                default: () => ({
                    src: '',
                    alt: '',
                    width: 40,
                    height: 40,
                }),
            },
        },

        methods: {
            /**
             * Replace ' with pink apostrophe.
             *
             * @param {string} text
             * @returns {string}
             */
            apostrophise(text) {
                return text.replace('\'', '<span class="itsu-pink">\'</span>');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .option {
        --icon-size: 32px;

        display: flex;
        align-items: center;
        gap: 8px;
    }

    .option-image {
        width: var(--icon-size);
        height: auto;
        display: block;
        padding-top: 4px;
        flex-shrink: 0;
    }

    .text {
        display: flex;
        flex-direction: column;
    }

    .option-text {
        font-weight: 700;
    }

    .option-subtext {
        color: secondary-palette(9);
        font-size: rem(14px);
        line-height: 1.2;
    }
</style>
